const trackUrls = new Map<string, string>();

/**
 * A `<track>` src for WebVTT kept in code. The build ships no .vtt files, so
 * the text becomes a blob URL once per document and is reused after that.
 */
export function createSubtitleTrackUrl(vtt: string): string {
  let url = trackUrls.get(vtt);
  if (!url) {
    url = URL.createObjectURL(new Blob([vtt], { type: "text/vtt" }));
    trackUrls.set(vtt, url);
  }
  return url;
}
